import React, { useState, useEffect } from "react";
import axiosInstance from "../utils/axiosInstance";
import HorizontalMenu from "../components/horizontalMenu";
import TrophyDescriptionComponent from "../components/TrophyDescriptionComponent";
import "../components/sections.css";
import ClipLoader from "react-spinners/ClipLoader"


function Trophies() {
  const [trophyData, setTrophyData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const override = {
    display: "block",
    margin: "0 auto",
    }

  useEffect(() => {
    axiosInstance
      .get("/trophies/data")
      .then((response) => {
        setTrophyData(response.data);
        setIsLoading(false);
      })
      .catch((error) => {});
  }, []);

  return (
    <div>
      <HorizontalMenu />
      <div style={{ padding: "10px"}}>
      <h3>Trophies</h3>
      <p className="trophies-intro" style={{ marginBottom: "15px" }}>
        Trophies serve as a mark of achievement and recognition in the Kluch
        Daily community. Trophies are awarded to members who satisfy the
        requirements for any given trophy. Complete challenges, earn
        trophies. It's that simple. So, what are you waiting for? Dive in and watch those trophies stack up!
      </p>

      <h3>Trophies List</h3>

      <ClipLoader loading={isLoading} cssOverride={override}/>

      {trophyData.map((trophy, index) => {
        return (
          <TrophyDescriptionComponent
            index={index}
            title={trophy.title}
            qualification={trophy.qualification}
            description={trophy.backstory}
            completed={trophy.completed}
          />
        );
      })}

      </div>

      {/* <div className="main-container">
        <div className="section1">
          Section 1
          <table>
            <thead>
              <tr>
                <th>Column 1</th>
                <th>Column 2</th>
                <th>Column 3</th>
                <th>Column 4</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Row </td>
                <td>Row </td>
                <td>Row</td>
                <td>Row </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="section2">Section 2</div>
        <div></div>
      </div> */}
    </div>
  );
}

export default Trophies;
